var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "M 19 3 C 13.488997 3 9 7.4889971 9 13 C 9 15.396508 9.8510142 17.597385 11.263672 19.322266 L 3.2929688 27.292969 L 4.7070312 28.707031 L 12.677734 20.736328 C 14.402615 22.148986 16.603492 23 19 23 C 24.511003 23 29 18.511003 29 13 C 29 7.4889971 24.511003 3 19 3 z M 19 5 C 23.430123 5 27 8.5698774 27 13 C 27 17.430123 23.430123 21 19 21 C 14.569877 21 11 17.430123 11 13 C 11 8.5698774 14.569877 5 19 5 z M 16 10 A 1 1 0 0 0 15 11 A 1 1 0 0 0 16 12 A 1 1 0 0 0 17 11 A 1 1 0 0 0 16 10 z M 22 10 A 1 1 0 0 0 21 11 A 1 1 0 0 0 22 12 A 1 1 0 0 0 23 11 A 1 1 0 0 0 22 10 z M 19 14 C 16.792859 14 15.345703 15.244141 15.345703 15.244141 A 1.0001 1.0001 0 1 0 16.654297 16.755859 C 16.654297 16.755859 17.515141 16 19 16 C 20.484859 16 21.345703 16.755859 21.345703 16.755859 A 1.0001 1.0001 0 1 0 22.654297 15.244141 C 22.654297 15.244141 21.207141 14 19 14 z",
    fontWeight: 400,
    fontFamily: "sans-serif",
    "white-space": "normal",
    overflow: "visible"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.075ddc62ae3ab574ec97e4407cf83446.svg";
export { ForwardRef as ReactComponent };